const WHITELIST_DOMAINS = ['nuclias.com'];
const SAFE_PROTOCOLS = ['http:', 'https:'];

const isPremises = () => process.env.REACT_APP_RUNNING_CONTEXT === 'premises';

const isWhitelistedDomain = (hostname) => {
    return WHITELIST_DOMAINS.some(domain =>
        hostname === domain || hostname.endsWith(`.${domain}`)
    );
};

const getSecureOrigin = () => {
    try {
        const currentUrl = new URL(window.location.origin);

        if (!SAFE_PROTOCOLS.includes(currentUrl.protocol)) {
            throw new Error(`not valid protocol`);
        }

        if (!isPremises() && !isWhitelistedDomain(currentUrl.hostname)) {
            throw new Error(`domain not valid`);
        }

        return currentUrl.origin;
    } catch (error) {
        throw error;
    }
};

const getSecureWebSocketURL = () => {
    try {
        const currentUrl = new URL(window.location.origin);

        if (!SAFE_PROTOCOLS.includes(currentUrl.protocol)) {
            throw new Error(`not valid protocol`);
        }

        if (!isPremises() && !isWhitelistedDomain(currentUrl.hostname)) {
            throw new Error(`domain not valid`);
        }

        const protocol = currentUrl.protocol === 'https:' ? 'wss:' : 'ws:';
        const hostname = currentUrl.hostname;
        const port = currentUrl.port ? `:${currentUrl.port}` : '';

        return `${protocol}//${hostname}${port}/ws/`;
    } catch (error) {
        throw error;
    }
};

const getServerURL = () => {
    const envServerURL = process.env.REACT_APP_SERVERURL;

    // 如果環境變數存在，直接使用（不進行檢查）
    if (envServerURL) {
        return envServerURL;
    }

    // 如果沒有環境變數，使用安全的 runtime 動態產生
    const secureOrigin = getSecureOrigin();
    return `${secureOrigin}/aspmm`;
};

const getAppApiURL = () => {
    const envServerURL = process.env.REACT_APP_API_URL;

    // 如果環境變數存在，直接使用（不進行檢查）
    if (envServerURL) {
        return envServerURL;
    }

    // 如果沒有環境變數，使用安全的 runtime 動態產生
    return getSecureOrigin();
};

const getWebSocketURL = () => {
    const envWebSocketURL = process.env.REACT_APP_WEBSOCKET_URL;

    // 如果環境變數存在，直接使用（不進行檢查）
    if (envWebSocketURL) {
        return envWebSocketURL;
    }

    // 如果沒有環境變數，使用安全的 runtime 動態產生
    return getSecureWebSocketURL();
};

/**
 * Check server environment from server URL
 * - rd: *.unity-rd*.nuclias.com, unity-rd*.nuclias.com
 * - qa: *.unity-qa*.nuclias.com, unity-qa*.nuclias.com
 * - prod: *.unity.nuclias.com, unity.nuclias.com
 * @example
 * getServerEnvironment()
 * // returns { enum: { RD: 'rd', QA: 'qa', PROD: 'prod', UNKNOWN: 'unknown' }, environment: 'rd' }
 * @returns
 * { enum: { RD: string, QA: string, PROD: string, UNKNOWN: string }, environment: string, isRDSite: function, isQASite: function, isProdSite: function, isUnknownSite: function }
 */
const getServerEnvironment = () => {
    const env = {
        serverURL: '',
        enum: {
            RD: 'rd',
            QA: 'qa',
            PROD: 'prod',
            UNKNOWN: 'unknown',
        },
        environment: '',
        isRDSite: function () {
            return this.environment === this.enum.RD;
        },
        isQASite: function () {
            return this.environment === this.enum.QA;
        },
        isProdSite: function () {
            return this.environment === this.enum.PROD;
        },
        isUnknownSite: function () {
            return this.environment === this.enum.UNKNOWN;
        },
    };

    const serverURL = getServerURL();
    env.serverURL = serverURL;

    try {
        const url = new URL(serverURL);
        const hostname = url.hostname;

        if (/^(.+\.)?unity-rd\d*\.nuclias\.com$/.test(hostname)) {
            env.environment = env.enum.RD;
        } else if (/^(.+\.)?unity-qa\d*\.nuclias\.com$/.test(hostname)) {
            env.environment = env.enum.QA;
        } else if (/^(.+\.)?unity\.nuclias\.com$/.test(hostname)) {
            env.environment = env.enum.PROD;
        } else {
            env.environment = env.enum.UNKNOWN;
        }
    } catch (error) {
        env.environment = env.enum.UNKNOWN;
    }

    return env;
}

export { getServerURL, getWebSocketURL, getAppApiURL, getServerEnvironment };